const flatten = <T>(list: T[], getChildren: (item: T) => T[]): T[] => {
  const allItems: T[] = [];

  // Un seul tableau alimenté par push : concat recopiait tout l'accumulateur à chaque élément (O(n²))
  const visit = (items: T[]): void => {
    items.forEach((currentItem) => {
      allItems.push(currentItem);
      const children = getChildren(currentItem);
      if (children) visit(children);
    });
  };

  visit(list);

  return allItems;
};

export default flatten;
